export interface Agent {
  id: string;
  name: string;
  emoji: string;
  description: string;
}

export const AGENTS: Agent[] = [
  { id: 'VERHAAL', name: 'Verhaal', emoji: '\u{1F4D6}', description: 'Memoir writer' },
  { id: 'SOVE', name: 'Sove', emoji: '\u{1F916}', description: 'AI companion' },
  { id: 'KOKKIN', name: 'Kokkin', emoji: '\u{1F373}', description: 'Kitchen & recipes' },
  { id: 'WETENSCHAP', name: 'Wetenschap', emoji: '\u{1F52C}', description: 'Research' },
  { id: 'KAART', name: 'Kaart', emoji: '\u{1F5FA}', description: 'Maps & location' },
  { id: 'ZIEL', name: 'Ziel', emoji: '\u{1F4AB}', description: 'Wellness' },
  { id: 'RAAD', name: 'Raad', emoji: '\u{1F3DB}', description: 'Council' },
  { id: 'SCOUT', name: 'Scout', emoji: '\u{1F3D8}', description: 'Buurthuis finder' },
  { id: 'TRANSPARANTIE', name: 'Transparantie', emoji: '\u{1F4CA}', description: 'Member updates' },
  { id: 'STEM', name: 'Stem', emoji: '\u{1F5E3}', description: 'Voice & features' },
  { id: 'GEZONDHEID', name: 'Gezondheid', emoji: '\u{1F49A}', description: 'Health' },
  { id: 'CC', name: 'CC', emoji: '\u{26A1}', description: 'Builder' },
];
